import React, {useEffect, useState} from "react";
import "./StudentAdminPage.sass";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {Paper, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {StyledTableCell, StyledTableRow} from "../../../_components/TableComponents";
import TableBody from "@mui/material/TableBody";
import Window from "../../../_containers/window/Window";
import {useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import {changeBalance, getStudents} from "../../../_actions/auth/authAdminService";
import Spinner from "../../common/anonymous/Spinner";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import DialogComponent from "../../../_components/common/dialog/DialogComponent";
import TextFieldEdit from "../../../_components/common/fields/TextFieldEdit";

export default function StudentAdminPage() {

    const [studentBalanceDialog, setStudentBalanceDialog] = useState();
    const [newBalance, setNewBalance] = useState("0");

    const {data: students, status} = useSelector(state => state.auth.getStudents);
    const {changeBalanceStatus} = useSelector(state => state.auth.student);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getStudents())
        }
    }, [status, dispatch]);
    useEffect(() => {
        if (changeBalanceStatus === SUCCESS) {
            dispatch(getStudents());
            setStudentBalanceDialog(null);
            setNewBalance("0");
        }
    }, [changeBalanceStatus, dispatch])

    if (status === IDLE || status === LOADING
        || changeBalanceStatus === LOADING) {
        return <Spinner/>
    }

    const handleSaveNewBalance = () => {
        const body = {
            studentId: studentBalanceDialog.id,
            balance: newBalance * 100
        }
        dispatch(changeBalance(body))
    }

    const renderStudentItem = (student) => {
        const {id, firstName, lastName, middleName, username, balance, isDeleted} = student;

        const renderBalance = () => {
            return <div className="StudentAdminPage-balance">
                <div className="StudentAdminPage-balance-value">{balance / 100}</div>
                <div className="StudentAdminPage-balance-button">
                    <ButtonComponent onClick={() => setStudentBalanceDialog(student)}>
                        Изменить
                    </ButtonComponent>
                </div>
            </div>
        }

        return <StyledTableRow key={`student-${id}`}>
            <StyledTableCell>{id}</StyledTableCell>
            <StyledTableCell>{lastName} {firstName} {middleName || ""}</StyledTableCell>
            <StyledTableCell>{username}</StyledTableCell>
            <StyledTableCell>{renderBalance()}</StyledTableCell>
            <StyledTableCell>{isDeleted ? "Удалён" : "Активен"}</StyledTableCell>
        </StyledTableRow>
    }

    return <Window>
        <div className="TeacherAdminPage-title">
            <div className="TeacherAdminPage-title-text">Список учеников</div>
            <CircleButton onClick={() => navigate(-1)} Icon={CloseIcon}/>
        </div>
        <div className="TeacherAdminPage-grid">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>ФИО</StyledTableCell>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell>Баланс</StyledTableCell>
                            <StyledTableCell>Статус</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {students.map(renderStudentItem)}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        {studentBalanceDialog && <DialogComponent open={!!studentBalanceDialog}
                                                  title={`Изменение баланса ученика: ${studentBalanceDialog.lastName} ${studentBalanceDialog.firstName}`}
                                                  buttons={{
                                                      accept: "Изменить",
                                                      cancel: "Назад",
                                                  }}
                                                  onAccept={handleSaveNewBalance}
                                                  onClose={() => {
                                                      setStudentBalanceDialog(false);
                                                      setNewBalance("0");
                                                  }}>
            <div style={{paddingBottom: '1em'}}>
                <span>Предыдущий баланс:</span> <span>{studentBalanceDialog.balance / 100}</span>
            </div>
            <TextFieldEdit label="Новый баланс"
                           value={newBalance}
                           onChange={(e) => setNewBalance(e.target.value)}
                           type="number"/>
        </DialogComponent>}
    </Window>
}